"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var BlurDiv_1 = __importDefault(require("atomicComponents/atoms/Div/BlurDiv"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Wrapper_1 = __importDefault(require("../Savings/styles/Wrapper"));
var selectors_1 = require("../selectors");
var AuditCallout_1 = __importDefault(require("./components/AuditCallout"));
var SavingsOpportunities_1 = __importDefault(require("./SavingOpportunityGraph/SavingsOpportunities"));
var ReportSavings = function () {
    var audit = (0, react_redux_1.useSelector)(selectors_1.selectLatestAudit);
    var isBlocked = (0, react_redux_1.useSelector)(selectors_1.selectBlockSaasAuditParts);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Saas Audit Savings Report", description: "Saas Audit Savings Report" }), (0, jsx_runtime_1.jsxs)(Wrapper_1.default, __assign({ sx: { overflow: isBlocked ? 'hidden' : 'auto' } }, { children: [(0, jsx_runtime_1.jsx)(AuditCallout_1.default, {}), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ maxWidth: 900, pt: 1, pl: 1 }, { children: [isBlocked && (0, jsx_runtime_1.jsx)(BlurDiv_1.default, {}), audit && ((0, jsx_runtime_1.jsx)(SavingsOpportunities_1.default, { limit: 20, totalSaasSpend: audit === null || audit === void 0 ? void 0 : audit.spendOverview.next12Months.forecast, showOthers: true, showBreakdown: true }))] }))] }))] }));
};
exports.default = ReportSavings;
